import { EntityState } from '@ngrx/entity';
import { ILog } from './ilog';

export interface ILogState extends EntityState<ILog> {
    // additional entities state properties
    error: any;
    selectedId: number | null;
}
